<h1 mat-dialog-title>Hi</h1>
<div mat-dialog-content>
  <p>{{ data }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
  <button mat-button [mat-dialog-close]>No Thanks</button>
</div>
